import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'ui/i18n';

import './ErrorMessage.scss';

export default class ErrorMessage extends Component {
	static propTypes = {
		show: PropTypes.bool.isRequired,
		messageId: PropTypes.string.isRequired,
		values: PropTypes.object,
	};

	static defaultProps = {
		values: {},
	};

	render() {
		const { show, messageId, values } = this.props;
		const showMsg = show ? 'show' : '';

		return (
			<div className={`ErrorMessage ${showMsg}`}>
				<FormattedMessage id={messageId} values={values} />
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/ui/components/ErrorMessage/index.js